/* eslint-disable local/no-raw-colors */
import React from 'react'
import { Defs, G, Mask, Path, Use } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const RecentIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Defs>
                <Path id='recentIconMaskShape' d='M0 0h24v24H0V13.997l6-2.163V8.37H0z' />
            </Defs>
            <G fill='none' fillRule='evenodd'>
                <G>
                    <Mask id='recentIconMask' fill='#fff'>
                        <Use href='#recentIconMaskShape' />
                    </Mask>
                    <Path
                        fill='currentColor'
                        mask='url(#recentIconMask)'
                        d='M12.528 6.584v5.256l4.488 2.664-.744 1.272-5.256-3.192v-6h1.512zM12 19.616c1.44 0 2.784-.368 4.032-1.104a7.772 7.772 0 0 0 2.88-2.88 7.802 7.802 0 0 0 1.104-4.032c0-1.44-.368-2.784-1.104-4.032a7.772 7.772 0 0 0-2.88-2.88A7.802 7.802 0 0 0 12 3.584c-1.44 0-2.784.368-4.032 1.104a7.772 7.772 0 0 0-2.88 2.88A7.802 7.802 0 0 0 3.984 11.6c0 1.44.368 2.784 1.104 4.032a7.772 7.772 0 0 0 2.88 2.88A7.802 7.802 0 0 0 12 19.616zm0-18c1.824 0 3.512.456 5.064 1.368a9.463 9.463 0 0 1 3.552 3.552 9.819 9.819 0 0 1 1.368 5.064 9.819 9.819 0 0 1-1.368 5.064 9.463 9.463 0 0 1-3.552 3.552A9.819 9.819 0 0 1 12 21.584a9.819 9.819 0 0 1-5.064-1.368 9.642 9.642 0 0 1-3.552-3.576 9.775 9.775 0 0 1-1.368-5.04c0-1.808.456-3.488 1.368-5.04A9.826 9.826 0 0 1 6.96 2.984 9.775 9.775 0 0 1 12 1.616z'
                    />
                </G>
                <Path fill='currentColor' d='M2.436 10.334L1.838 5.37l5.196 3z' />
            </G>
        </>
    ),
})

RecentIcon.displayName = 'RecentIcon'
